import React from "react";
import { Typography } from "antd";
import CustomerList from "../../components/customer/CustomerListComponent";
const { Title } = Typography;

const CustomersPage = () => {
  return (
    <div className="customers-container" style={{ padding: "20px" }}>
      <Title level={2}>Müşteriler</Title>
      <CustomerList />
    </div>
  );
};

export default CustomersPage;
